<template>
<v-layout column>
    <v-flex xs12>
    <v-layout row wrap>
        <v-flex xs12>
            <v-layout row wrap>
                <v-flex xs12 pb-3>
                    <h3 class="headline">
                        {{$t('REGISTRATION_STUDENT_INVITATION_CODE')}}
                    </h3>
                </v-flex>
                <v-flex xs12>
                    <p>{{$t('REGISTRATION_STUDENT_MESSAGE')}}</p>
                    <v-layout>
                        <v-spacer v-if="isUSCR"/>
                        <v-btn 
                                :dark="true"
                                color="primary"
                                @click="confirm"
                                class="elevation-0 ml-0"
                                :aria-label="$t('REGISTRATION_STUDENT_ACTION_BUTTON')">
                            {{$t('REGISTRATION_STUDENT_ACTION_BUTTON')}}
                        </v-btn>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
    </v-flex>
    </v-layout>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component';
import Config from '@/config';
import { resolve } from 'url';

@Component({ components: { }})
export default class StudentRegistration extends Vue {
    get isUSCR(): boolean {
        return Config.BASE_DOMAIN === 'USCR';
    }
    
    confirm() {
        window.location.href = resolve(Config.LOGIN_UI_BASE_URL, `/registration`);
    }
}
</script>